import { cn } from '@client/lib/utils';

interface IOSToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function IOSToggle({ checked, onChange, disabled }: IOSToggleProps) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative w-[51px] h-[31px] rounded-full transition-colors duration-200',
        checked ? 'bg-[#34C759]' : 'bg-[#E9E9EB] dark:bg-[#39393D]',
        disabled && 'opacity-50'
      )}
    >
      <span
        className={cn(
          'absolute top-[2px] left-[2px] w-[27px] h-[27px] bg-white rounded-full shadow-sm',
          'transition-transform duration-200',
          checked && 'translate-x-[20px]'
        )}
      />
    </button>
  );
}
